import Vue from 'vue'
import VueMask from 'v-mask'
Vue.use(VueMask)
export default VueMask;

//https://github.com/probil/v-mask